import React from "react";

interface AppSpinnerProps {
    size?: number;
    color?: string;
    loading?: boolean;
    className?: string;
}

const AppSpinner: React.FC<AppSpinnerProps> = ({
    size = 40,
    color = "#a794ed",
    loading = true,
    className = ""
}) => {
    if (!loading) return null;

    return (
        <div className={`app-spinner-wrap ${className}`} style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: size,
            height: size,
            transform: `scale(${size / 200})`, // native 200x200
            transformOrigin: "center",
            position: "relative"
        }}>
            <style>{`
                .liquid-loader-wrapper {
                    align-items: center;
                    display: flex;
                    height: 100%;
                    justify-content: center;
                    overflow: visible;
                    position: relative;
                    width: 200px;
                    height: 200px;
                }
                .liquid-loader-gegga {
                    width: 0;
                    height: 0;
                    position: absolute;
                }
                .liquid-loader-snurra {
                    filter: url(#gegga) drop-shadow(0px 8px 16px rgba(255, 126, 179, 0.45));
                }
                .liquid-loader-stopp1 {
                    stop-color: #ff7eb3; /* darker pastel pink */
                }
                .liquid-loader-stopp2 {
                    stop-color: #ff9a44; /* pastel orange */
                }
                .liquid-loader-halvan {
                    animation: Snurra1 10s infinite linear;
                    stroke-dasharray: 180 800;
                    fill: none;
                    stroke: url(#liquidGradient);
                    stroke-width: 23;
                    stroke-linecap: round;
                }
                .liquid-loader-strecken {
                    animation: Snurra1 3s infinite linear;
                    stroke-dasharray: 26 54;
                    fill: none;
                    stroke: url(#liquidGradient);
                    stroke-width: 23;
                    stroke-linecap: round;
                }

                @keyframes Snurra1 {
                    0% {
                        stroke-dashoffset: 0;
                    }
                    100% {
                        stroke-dashoffset: -403px;
                    }
                }
            `}</style>
            <div className="liquid-loader-wrapper">
                <svg className="liquid-loader-gegga">
                    <defs>
                        <filter id="gegga">
                            <feGaussianBlur in="SourceGraphic" stdDeviation="7" result="blur" />
                            <feColorMatrix
                                in="blur"
                                mode="matrix"
                                values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 20 -10"
                                result="inreGegga"
                            />
                            <feComposite in="SourceGraphic" in2="inreGegga" operator="atop" />
                        </filter>
                    </defs>
                </svg>
                <svg className="liquid-loader-snurra" width="200" height="200" viewBox="0 0 200 200" style={{ position: 'absolute' }}>
                    <defs>
                        <linearGradient id="linjärGradient">
                            <stop className="liquid-loader-stopp1" offset="0" />
                            <stop className="liquid-loader-stopp2" offset="1" />
                        </linearGradient>
                        <linearGradient
                            y2="160"
                            x2="160"
                            y1="40"
                            x1="40"
                            gradientUnits="userSpaceOnUse"
                            id="liquidGradient"
                            href="#linjärGradient"
                        />
                    </defs>
                    <path
                        className="liquid-loader-halvan"
                        d="m 164,100 c 0,-35.346224 -28.65378,-64 -64,-64 -35.346224,0 -64,28.653776 -64,64 0,35.34622 28.653776,64 64,64 35.34622,0 64,-26.21502 64,-64 0,-37.784981 -26.92058,-64 -64,-64 -37.079421,0 -65.267479,26.922736 -64,64 1.267479,37.07726 26.703171,65.05317 64,64 37.29683,-1.05317 64,-64 64,-64"
                    />
                    <circle className="liquid-loader-strecken" cx="100" cy="100" r="64" />
                </svg>
            </div>
        </div>
    );
};

export default AppSpinner;
